export default __webpack_public_path__ + "static/media/iconFinConta.dfeb8a32.png";